import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";
import type { IMatch } from "~src/interfaces";
import { usecommonStore } from "~src/stores/CommonStore";

const __default__ = {};

interface Props {
  match: IMatch;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ProgressBar',
  props: {
    match: {}
  },
  setup(__props: any) {

const commonStore = usecommonStore();
const props = __props;
const siteName = computed(() => commonStore.getSiteName);

const width = computed(() => {
  // if (props.match.match_time_player) {
  //   if (props.match.match_time_player.process < 20) {
  //     value = 20;
  //   } else if (props.match.match_time_player.process > 95) {
  //     value = 95;
  //   } else {
  //     value = props.match.match_time_player.process;
  //   }
  // }

  let value = props.match?.match_time_player?.process ?? 0;
  return value;
});

const borderBottomRightRadius = computed(() => {
  let value = 0;
  if (props.match.match_time_player) {
    if (props.match.match_time_player.process > 90) {
      value = 45;
    } else if (props.match.match_time_player.process > 80) {
      value = 20;
    }
  }
  return value;
});

const progressStyle = computed(() => {
  let _clip_path = "";
  const array = ["xoilacz", "rakhoi", "xoilac86", "soco", "vebo", "mitom", "vaoroi", "xoilaclink", "xoilacvnn", "xoilaczxc"];
  if (array.includes(siteName.value)) {
    if (width.value < 26) {
      _clip_path = "polygon(0% 0%, 100% 0%, 12px 100%, 12px 100%)";
    }
  }
  return {
    position: "absolute",
    left: "3px",
    top: "2px",
    height: "86%",
    borderBottomLeftRadius: "60px",
    width: `${width.value}%`,
    borderBottomRightRadius: `${borderBottomRightRadius.value}px`,
    clipPath: _clip_path,
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`as-progress-bar as-progress-bar-${siteName.value}`),
    style: _normalizeStyle(progressStyle.value)
  }, null, 6))
}
}

})